import Products from './List'
import Product from './Product'

export { Product }

export default Products
